const STORAGE_KEY = 'elcelon_recently_viewed_products';
const MAX_STORED = 12;

function readStored() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function writeStored(list) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
  } catch (e) {
    /* localStorage unavailable, fail silently */
  }
}

function recordCurrentProduct(host) {
  const script = host.querySelector('script[data-current-product]');
  if (!script) return;

  let current;
  try {
    current = JSON.parse(script.textContent);
  } catch (e) {
    return;
  }
  if (!current || !current.handle) return;

  let list = readStored();
  list = list.filter((item) => item.handle !== current.handle);
  list.unshift(current);
  writeStored(list);
}

function renderList(host) {
  const container = host.querySelector('[data-recently-viewed-list]');
  if (!container) return;

  const currentHandle = host.dataset.currentHandle || '';
  const max = parseInt(host.dataset.max, 10) || 6;

  const items = readStored()
    .filter((item) => item.handle !== currentHandle)
    .slice(0, max);

  if (items.length === 0) {
    host.setAttribute('data-empty', 'true');
    return;
  }

  host.setAttribute('data-empty', 'false');

  const fragment = document.createDocumentFragment();
  items.forEach((item) => {
    const link = document.createElement('a');
    link.className = 'recently-viewed-card';
    link.href = item.url || '#';

    const media = document.createElement('div');
    media.className = 'recently-viewed-card__media';
    if (item.image) {
      const img = document.createElement('img');
      img.src = item.image;
      img.loading = 'lazy';
      img.alt = item.title || '';
      media.appendChild(img);
    }

    const title = document.createElement('p');
    title.className = 'recently-viewed-card__title';
    title.textContent = item.title || '';

    const price = document.createElement('p');
    price.className = 'recently-viewed-card__price';
    price.textContent = item.price || '';

    link.appendChild(media);
    link.appendChild(title);
    link.appendChild(price);
    fragment.appendChild(link);
  });

  container.innerHTML = '';
  container.appendChild(fragment);
}

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    recordCurrentProduct(this);
    renderList(this);
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
export { RecentlyViewedProducts as RecentlyViewed };